import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ComunicationService {
    private _listners;


    listen(): Observable<any> {
      this._listners = new Subject<any>();
       return this._listners.asObservable();
    }

    callMethodGeneral(filterBy: string) {
      // if(this._listners.observers.length > 1)
      //   this._listners.observers = [];
       this._listners.next(filterBy);
    }

}
